<template lang="pug">
#processos-judiciais-totalizadores
    BaseTableHeader(
        :icone-titulo-tabela='iconeTituloTabela',
        :titulo-tabela='tituloTabela'
    )
    el-alert(
        v-if='!dados.processoJudicialTotalizadores',
        :title="$t('mensagens.preAnaliseCredito.processosJudiciais.naoHaRegistroDeProcessosJudiciais')",
        type='warning',
        :closable='false'
    )
    div(v-if="dados.processoJudicialTotalizadores && (dados.processoJudicialTotalizadores.nomeIgual.totalizadores.length > 0 || dados.processoJudicialTotalizadores.documento.totalizadores.length > 0)")
        span.titulo-card {{ $t('mensagens.preAnaliseCredito.processosJudiciais.resumo') }}
        .info-grid
            .info-item
                .label {{ $t('mensagens.preAnaliseCredito.processosJudiciais.total') }}
                .value {{ totalizadores.quantidadeTotal }}
            .info-item
                .label {{ $t('mensagens.preAnaliseCredito.processosJudiciais.ativos') }}
                .value {{ totalizadores.quantidadeAtivos }}
            .info-item
                .label {{ $t('mensagens.preAnaliseCredito.processosJudiciais.comParteAtiva') }}
                .value {{ totalizadores.quantidadeTotalAtivos }}
            .info-item
                .label {{ $t('mensagens.preAnaliseCredito.processosJudiciais.comPartePassiva') }}
                .value {{ totalizadores.quantidadeTotalPassivos }}
            .info-item
                .label {{ $t('mensagens.preAnaliseCredito.processosJudiciais.comOutrasPartes') }}
                .value {{ totalizadores.quantidadeTotalOutrasPartes }}
            .see-more
                a.see-more-link(href="#" @click.prevent='openModal') {{ $t('mensagens.preAnaliseCredito.verValoresCausas') }}
                    i(class="mdi mdi-arrow-right arrow-icon")

    div(v-if="(historico && totalProcessos) || isInfoResumo")
        span.titulo-card {{ $t('mensagens.preAnaliseCredito.processosJudiciais.resumoVisualizacao') }}
        div.gray-margin.mt-2
            .info-grid-4
                div
                    span {{ $t('mensagens.preAnaliseCredito.processosJudiciais.total') }}:
                    span.bold-green.ml-2 {{ totalProcessos || '0' }}
                div
                    span {{ $t('mensagens.preAnaliseCredito.processosJudiciais.visualizados') }}:
                    span.bold-green.ml-2 {{ totalConsultados || '0' }}
                div
                    span {{ $t('mensagens.preAnaliseCredito.processosJudiciais.naoVisualizados') }}:
                    span.bold-green.ml-2 {{ totalNaoConsultados || '0' }}
                div
                    span {{ $t('mensagens.preAnaliseCredito.processosJudiciais.creditosConsumidos') }}:
                    span.bold-red.ml-2 {{ qdeCreditosConsumidos || '0' }}

    div(v-if="!historico && isBotaoVisualizarMais")
        span.titulo-card {{ $t('mensagens.preAnaliseCredito.processosJudiciais.resumoVisualizacao') }}
        .info-grid-2-220
            div.gray-margin
                .info-grid-4
                    div
                        span {{ $t('mensagens.preAnaliseCredito.processosJudiciais.total') }}:
                        span.bold-green.ml-2 {{ totalProcessos || '0' }}
                    div
                        span {{ $t('mensagens.preAnaliseCredito.processosJudiciais.visualizados') }}:
                        span.bold-green.ml-2 {{ totalConsultados || '0' }}
                    div
                        span {{ $t('mensagens.preAnaliseCredito.processosJudiciais.naoVisualizados') }}:
                        span.bold-green.ml-2 {{ totalNaoConsultados || '0'}}
                    div
                        span {{ $t('mensagens.preAnaliseCredito.processosJudiciais.creditosConsumidos') }}:
                        span.bold-red.ml-2 {{ qdeCreditosConsumidos || '0' }}
            BaseButton(
                type='primary',
                v-loading='isLoading'
                @click='maisProcessos()'
            )
                | {{ $t('mensagens.preAnaliseCredito.processosJudiciais.visualizarMaisProcessos') }}

    div.mt-3(v-if='!historico && totalProcessos && totalProcessos === totalNaoConsultados')
        span.titulo-card {{ $t('mensagens.preAnaliseCredito.processosJudiciais.visualizarProcessos') }}
        el-tooltip(
            effect='dark',
            placement='right-start'
        )
            div(slot='content')
                span {{ $t('mensagens.preAnaliseCredito.processosJudiciais.escolherQuantidadeProcessos') }}
                br
                span {{ $t('mensagens.preAnaliseCredito.processosJudiciais.maisDetalhadasComo') }}:
                br
                span • {{ $t('mensagens.preAnaliseCredito.processosJudiciais.numeroCNJ') }}
                br
                span • {{ $t('mensagens.preAnaliseCredito.processosJudiciais.movimentacoes') }}
                br
                span • {{ $t('mensagens.preAnaliseCredito.processosJudiciais.categoriaProcesso') }}
                br
                span • {{ $t('mensagens.preAnaliseCredito.processosJudiciais.partesAtivas') }}
                br
                span • {{ $t('mensagens.preAnaliseCredito.processosJudiciais.outrasInformacoes') }}
            i.el-icon-info
        div.alert-box
            .info-grid-qde
                span.mt-2 {{ $t('mensagens.preAnaliseCredito.processosJudiciais.digiteQuantidadeProcessos') }}
                el-input-number(
                    style='min-width:100%',
                    v-model='qdeProcessos',
                    :step='qdeProcessosRequisicao',
                    :min='0',
                    :max='totalProcessos',
                    @change='atualizarCreditos()'
                )
                BaseButton(
                    type='primary',
                    v-loading='isLoading'
                    @click='confirmarVisualizacao()'
                )
                    | {{ $t('mensagens.comuns.confirmar') }}
            .info-grid-2
                div.gray
                    span {{ $t('mensagens.preAnaliseCredito.processosJudiciais.processosSeremVisualizados') }}:
                    span.ml-2.bold {{ qdeProcessos }}
                    span.ml-5 {{ $t('mensagens.preAnaliseCredito.processosJudiciais.creditosSeremConsumidos') }}:
                    span.ml-2.bold-red {{ qdeCreditos }}
                BaseButton(
                    type='primary',
                    :disabled='!isVisualizar'
                    v-loading='isLoading'
                    @click='loadCarregarProcessos()'
                )
                    | {{ $t('mensagens.comuns.visualizar') }}
            hr
            .centralizado
                a.see-more-link-regras(href="#" @click.prevent='openAlertModal') {{ $t('mensagens.preAnaliseCredito.processosJudiciais.verRegrasConsumoCreditos') }}

    div.mt-5(v-if='totalConsultados > 0')
        el-input.mr-3(
            v-model='filtroProcessos'
            prefix-icon='el-icon-search',
            style='width:300px',
            :placeholder= "[$t('mensagens.preAnaliseCredito.processosJudiciais.pesquisarProcesso')]",
            v-mask='["#######.##.####.#.##.####"]'
        )
        el-tooltip(
            effect='dark',
            placement='top-start',
            :content= "[$t('mensagens.comuns.pesquisar')]",
        )
            BaseButton.button-pesquisar(
                style='padding: 12px',
                type='primary',
                icon='el-icon-search',
                @click='filtrarProcessos()'
            )
        el-tooltip(
            v-if='isLimparPesquisa',
            effect='dark',
            placement='top-start',
            :content= "[$t('mensagens.comuns.limparPesquisa')]",
        )
            BaseButton.button-pesquisar(
                type='danger',
                icon='el-icon-delete',
                @click='limparFiltroProcessos()'
            )

    TabelaProcessosJudiciaisPf.table-processos(
        v-if='isPessoaFisicaLocal && canRender',
        :dados='resultadoConsulta || {}',
        :on-page-change='handlePageChange',
        :loading-page='loadingTable',
        :paginaAtual='paginacao.paginaAtual',
        :totalPages='totalPaginasConsulta'
    )

    TabelaProcessosJudiciaisPj.table-processos(
        v-if='isPessoaJuridicaLocal && canRender',
        :dados='resultadoConsulta || {}',
        :on-page-change='handlePageChange',
        :loading-page='loadingTable',
        :paginaAtual='paginacao.paginaAtual',
        :totalPages='totalPaginasConsulta'
    )

    BaseModalGeral(
        v-if='modalDetalhesProcessos',
        :show='modalDetalhesProcessos',
        mostrarBotaoConfirmar=false,
        :title="$t('mensagens.preAnaliseCredito.verValoresCausas')",
        width='900px',
        @closeDialog='modalDetalhesProcessos = false;'
    )
        div(v-if='dados.processoJudicialTotalizadores.valorTotal')
            BaseInfoBlock(
                :titulos-info-block="[$t('mensagens.preAnaliseCredito.processosJudiciais.somaValorTotalDasCausas'), $t('mensagens.preAnaliseCredito.processosJudiciais.somaValorTotalDasCausasComOutrasPartes')]",
                :valores-info-block='[formatValorBRL(dados.processoJudicialTotalizadores.valorTotal), formatValorBRL(dados.processoJudicialTotalizadores.valorTotalOutrasPartes)]'
            )
        el-divider
        div(
            v-if='dados.processoJudicialTotalizadores.valorTotalAtiva'
        )
            BaseInfoBlock(
                :titulos-info-block="[$t('mensagens.preAnaliseCredito.processosJudiciais.somaValorDasCausasParteAtiva'), $t('mensagens.preAnaliseCredito.processosJudiciais.somaValorDasCausasPartePassiva')]",
                :valores-info-block='[formatValorBRL(dados.processoJudicialTotalizadores.valorTotalAtiva), formatValorBRL(dados.processoJudicialTotalizadores.valorTotalPassiva)]'
            )

    BaseModalGeral(
        v-if='modalRegrasConsumo',
        :show='modalRegrasConsumo',
        mostrarBotaoConfirmar=false,
        :title="$t('mensagens.preAnaliseCredito.processosJudiciais.regrasConsumoCreditos')",
        width='620px',
        @closeDialog='modalRegrasConsumo = false;'
    )
        div.modal-info-text
        p.p-fix {{ $t('mensagens.preAnaliseCredito.processosJudiciais.regrasConsumo.consultasFontes') }}.

        span 1. {{ $t('mensagens.preAnaliseCredito.processosJudiciais.regrasConsumo.informacoes') }}
        p.ml-3.pt-2 1.1. {{ $t('mensagens.preAnaliseCredito.processosJudiciais.regrasConsumo.100processos') }}
            span.bold.ml-1 1 {{ $t('mensagens.preAnaliseCredito.processosJudiciais.regrasConsumo.unidadeCredito') }}.
        p.ml-3 1.2. {{ $t('mensagens.preAnaliseCredito.processosJudiciais.regrasConsumo.naoAtingir100') }}
            span.bold.ml-1 1 {{ $t('mensagens.preAnaliseCredito.processosJudiciais.regrasConsumo.unidadeCredito') }}.
        p.ml-3 1.3. {{ $t('mensagens.preAnaliseCredito.processosJudiciais.regrasConsumo.200processos') }}
            span.bold.ml-1 2 {{ $t('mensagens.preAnaliseCredito.processosJudiciais.regrasConsumo.unidadesCredito') }}.
        p.ml-3 1.4. {{ $t('mensagens.preAnaliseCredito.processosJudiciais.regrasConsumo.100a200processos') }}
            span.bold.ml-1 2 {{ $t('mensagens.preAnaliseCredito.processosJudiciais.regrasConsumo.unidadesCredito') }}.

        span 2. {{ $t('mensagens.preAnaliseCredito.processosJudiciais.regrasConsumo.exemplos') }}
        p.ml-3.pt-2 2.1. {{ $t('mensagens.preAnaliseCredito.processosJudiciais.regrasConsumo.exemplos100processos') }}
        p.ml-3 2.2. {{ $t('mensagens.preAnaliseCredito.processosJudiciais.regrasConsumo.exemplos32processos') }}
        p.ml-3 2.3. {{ $t('mensagens.preAnaliseCredito.processosJudiciais.regrasConsumo.exemplos200processos') }}
        p.ml-3 2.4. {{ $t('mensagens.preAnaliseCredito.processosJudiciais.regrasConsumo.exemplos125processos') }}

        span 3. {{ $t('mensagens.preAnaliseCredito.processosJudiciais.regrasConsumo.visualizacaoProcessos') }}
        p.ml-3.pt-2 3.1. {{ $t('mensagens.preAnaliseCredito.processosJudiciais.regrasConsumo.consultaFeita') }}.
        p.ml-3.mb-2 3.2. {{ $t('mensagens.preAnaliseCredito.processosJudiciais.regrasConsumo.quantidadeNaoAtingir') }}.

    BaseModalGeral(
        v-if='modalConfirmacaoProcessos',
        :show='modalConfirmacaoProcessos',
        :title="$t('mensagens.preAnaliseCredito.processosJudiciais.visualizarProcessos')",
        mostrarBotaoConfirmar=true,
        :nomeBotaoAcao="$t('mensagens.comuns.continuar')",
        width='550px',
        @confirmDialog='processarConsultaProcessos()'
        @closeDialog='modalConfirmacaoProcessos = false;'
    )
        div.modal-info-text
            p.pt-2 {{ $t('mensagens.preAnaliseCredito.processosJudiciais.visualizarProcessosDocumento') }}
                span.bold.ml-1 {{ numeralStringFormatToDocumento($route.params.cpfCnpj) }}.
            p.bold {{ $t('mensagens.preAnaliseCredito.processosJudiciais.resumo') }}
            .info-grid-proc
                span {{ $t('mensagens.preAnaliseCredito.processosJudiciais.quantidadeProcessos') }}:
                div.bold {{ qdeProcessos }}
                div.row-border
                span {{ $t('mensagens.preAnaliseCredito.processosJudiciais.creditosSeremConsumidos') }}:
                span.bold {{ qdeCreditos }}

    BaseModalGeral(
        v-if='modalMaisProcessos',
        :show='modalMaisProcessos',
        :title="$t('mensagens.preAnaliseCredito.processosJudiciais.visualizarMaisProcessos')",
        :mostrarBotaoConfirmar='isVisualizarMais',
        :nomeBotaoAcao="$t('mensagens.comuns.continuar')",
        width='555px',
        @confirmDialog='processarConsultaMaisProcessos()'
        @closeDialog='modalMaisProcessos = false;'
    )
        div.modal-info-text
            p.pt-2 {{ $t('mensagens.preAnaliseCredito.processosJudiciais.digiteQuantidadeProcessos') }}
                span.bold.ml-1 {{ $t('mensagens.preAnaliseCredito.processosJudiciais.aMais') }}.
            .info-grid-2
                el-input-number(
                    style='width:100%',
                    v-model='qdeMaisProcessos',
                    :step='qdeProcessosRequisicao',
                    :min='0',
                    :max='totalProcessos',
                    @change='atualizarMaisCreditos()'
                )
                BaseButton(
                    type='primary',
                    v-loading='isLoading'
                    @click='confirmarMaisVisualizacao()'
                )
                    | {{ $t('mensagens.comuns.confirmar') }}
            div.gray.mb-5
                span {{ $t('mensagens.preAnaliseCredito.processosJudiciais.quantidadeProcessos') }}:
                span.ml-2.bold {{ qdeMaisProcessos }}
                span.ml-5 {{ $t('mensagens.preAnaliseCredito.processosJudiciais.creditosSeremConsumidos') }}:
                span.ml-2.bold-red {{ qdeMaisCreditos }}

</template>

<script>
import formatters from '@/utils/formatters';

import preAnaliseServiceMixin from '@/mixins/PreAnaliseCreditoMixin';

import BaseTableHeader from '@/components/preAnaliseCredito/BaseTableHeader';
import BaseInfoBlock from '@/components/preAnaliseCredito/BaseInfoBlock';
import BaseModalGeral from '@/components/preAnaliseCredito/BaseModalGeral.vue';
import TabelaProcessosJudiciaisPf from './TabelaProcessosJudiciaisPf.vue';
import TabelaProcessosJudiciaisPj from './TabelaProcessosJudiciaisPj.vue';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';
import PreAnaliseService from '@/services/PreAnaliseCredito';

export default {
    name: 'ProcessosJudiciaisTotalizadores',

    components: {
        BaseTableHeader,
        TabelaProcessosJudiciaisPf,
        TabelaProcessosJudiciaisPj,
        BaseInfoBlock,
        BaseModalGeral,
        BaseButton
    },

    mixins: [preAnaliseServiceMixin],

    props: {
        tituloTabela: {
            type: String,
            required: false,
            default: 'Tabela'
        },
        isPessoaFisica: {
            type: Boolean,
            required: false,
            default: false
        },
        isPessoaJuridica: {
            type: Boolean,
            required: false,
            default: false
        },
        iconeTituloTabela: {
            type: String,
            required: false,
            default: 'mdi mdi-cloud-search-outline'
        },
        dados: {
            type: Object,
            required: true,
            default: () => { }
        }
    },

    data() {
        return {
            totalProcessos: null,
            totalConsultados: 0,
            totalNaoConsultados: 0,
            totalPaginasConsulta: 0,
            historico: null,
            forceUpdateKey: 0,
            id: this.$route.params.id,
            modalDetalhesProcessos: false,
            modalRegrasConsumo: false,
            modalConfirmacaoProcessos: false,
            modalMaisProcessos: false,
            activeCollapseItem: [''],
            canRender: false,
            processos: null,
            isPessoaFisicaLocal: this.isPessoaFisica,
            isPessoaJuridicaLocal: this.isPessoaJuridica,
            isLoading: false,
            isVisualizar: false,
            isVisualizarMais: false,
            isBotaoVisualizarMais: false,
            isInfoResumo: false,
            loadingTable: false,
            qdeProcessos: 0,
            qdeCreditos: 0,
            qdeMaisProcessos: 0,
            qdeMaisCreditos: 0,
            qdeCreditosConsumidos: 0,
            qdeProcessosRequisicao: 100,
            filtroProcessos: '',
            isLimparPesquisa: false,
            paginacao: {
                paginaAtual: 1,
                tamanhoPagina: 10
            },
            totalizadores: {
                quantidadeTotal: 0,
                quantidadeAtivos: 0,
                quantidadeTotalAtivos: 0,
                quantidadeTotalPassivos: 0,
                quantidadeTotalOutrasPartes: 0
            }
        };
    },

    async mounted() {
        this.historico = this.$route.params.historico;

        if (this.dados.processoJudicialTotalizadores && this.dados.processoJudicialTotalizadores.nomeIgual.totalizadores.length > 0) {
            this.totalizadores.quantidadeTotal = this.dados.processoJudicialTotalizadores.nomeIgual.totalizadores[0].quantidadeTotal;
            this.totalizadores.quantidadeAtivos = this.dados.processoJudicialTotalizadores.nomeIgual.totalizadores[0].quantidadeAtivos;
            this.totalizadores.quantidadeTotalAtivos = this.dados.processoJudicialTotalizadores.nomeIgual.totalizadores[0].quantidadeTotalAtivos;
            this.totalizadores.quantidadeTotalPassivos = this.dados.processoJudicialTotalizadores.nomeIgual.totalizadores[0].quantidadeTotalPassivos;
            this.totalizadores.quantidadeTotalOutrasPartes = this.dados.processoJudicialTotalizadores.nomeIgual.totalizadores[0].quantidadeTotalOutrasPartes;
        }

        if (this.dados.processoJudicialTotalizadores && this.dados.processoJudicialTotalizadores.documento.totalizadores.length > 0) {
            this.totalizadores.quantidadeTotal = this.totalizadores.quantidadeTotal + this.dados.processoJudicialTotalizadores.documento.totalizadores[0].quantidadeTotal;
            this.totalizadores.quantidadeAtivos = this.totalizadores.quantidadeAtivos + this.dados.processoJudicialTotalizadores.documento.totalizadores[0].quantidadeAtivos;
            this.totalizadores.quantidadeTotalAtivos = this.totalizadores.quantidadeTotalAtivos + this.dados.processoJudicialTotalizadores.documento.totalizadores[0].quantidadeTotalAtivos;
            this.totalizadores.quantidadeTotalPassivos = this.totalizadores.quantidadeTotalPassivos + this.dados.processoJudicialTotalizadores.documento.totalizadores[0].quantidadeTotalPassivos;
            this.totalizadores.quantidadeTotalOutrasPartes = this.totalizadores.quantidadeTotalOutrasPartes + this.dados.processoJudicialTotalizadores.documento.totalizadores[0].quantidadeTotalOutrasPartes;
        }

        this.totalProcessos = this.totalizadores.quantidadeTotal;
        this.totalNaoConsultados = this.totalProcessos ? this.totalProcessos - this.totalConsultados : 0;

        if (this.$route.params.cpfCnpj.length === 11) {
            this.isPessoaFisicaLocal = true;
        } else {
            this.isPessoaJuridicaLocal = true;
        }

        await this.carregarProcessosJudiciaisHistorico();
    },

    methods: {
        async carregarProcessosJudiciais(size) {
            let idConsulta = this.dados.idConsultaNeoway;

            await PreAnaliseService.pesquisaNeowayProcessos({
                idConsulta,
                size
            }).then(({ data }) => {
                this.resultadoConsulta = {
                    ...data
                };

                if (this.resultadoConsulta) {
                    this.totalConsultados = this.resultadoConsulta.total || 0;
                    this.totalPaginasConsulta = this.resultadoConsulta.total || 0;
                    this.totalNaoConsultados = this.totalProcessos ? this.totalProcessos - this.totalConsultados : 0;
                    this.qdeProcessosRequisicao = this.resultadoConsulta.qdeProcessosRequisicao || 0;
                    this.qdeCreditosConsumidos = this.totalConsultados > 0 ? Math.ceil(this.totalConsultados / this.qdeProcessosRequisicao) : 0;
                    
                    if (this.resultadoConsulta.qdeInferiorProcessos) {
                        this.isBotaoVisualizarMais = false;
                        this.isInfoResumo = true;
                    } else {
                        this.isBotaoVisualizarMais = this.totalProcessos && this.totalProcessos > this.totalConsultados && this.totalProcessos > this.totalNaoConsultados;
                        this.isInfoResumo = this.totalProcessos && this.totalProcessos > 0 && this.totalProcessos === this.totalConsultados;
                    }
                    this.canRender = true;
                }

                this.paginacao.paginaAtual = 1;
                this.qdeMaisProcessos = 0;
                this.qdeMaisCreditos = 0;
                this.isVisualizarMais = false;
                this.filtroProcessos = '';
            }).catch(() => {
                this.$notify.error({
                    message: 'Erro ao buscar os processos.'
                });
            });
        },

        async carregarProcessosJudiciaisHistorico(paginaAtual = this.paginacao.paginaAtual) {
            this.paginacao.paginaAtual = paginaAtual;

            let idConsultaNeoway = this.id;
            let size = this.paginacao.tamanhoPagina;
            let page = this.paginacao.paginaAtual - 1;
            let filtro = this.filtroProcessos;

            await PreAnaliseService.visualizarHistoricoNeowayProcessos({
                idConsultaNeoway,
                size,
                page,
                filtro
            }).then(({ data }) => {
                this.resultadoConsulta = {
                    ...data
                };

                if (this.resultadoConsulta && !filtro) {
                    this.totalConsultados = this.resultadoConsulta.total || 0;
                    this.totalNaoConsultados = this.totalProcessos ? this.totalProcessos - this.totalConsultados : 0;
                    this.qdeProcessosRequisicao = this.resultadoConsulta.qdeProcessosRequisicao || 0;
                    this.qdeCreditosConsumidos = this.totalConsultados > 0 ? Math.ceil(this.totalConsultados / this.qdeProcessosRequisicao) : 0;
                    
                    if (this.resultadoConsulta.qdeInferiorProcessos) {
                        this.isBotaoVisualizarMais = false;
                        this.isInfoResumo = true;
                    } else {
                        this.isBotaoVisualizarMais = this.totalProcessos && this.totalProcessos > this.totalConsultados && this.totalProcessos > this.totalNaoConsultados;
                        this.isInfoResumo = this.totalProcessos && this.totalProcessos > 0 && this.totalProcessos === this.totalConsultados;
                    }
                }

                this.totalPaginasConsulta = this.resultadoConsulta.total || 0;
                this.canRender = true;
            }).catch(() => {
                this.$notify.error({
                    message: 'Erro ao buscar os processos.'
                });
            });
        },

        async filtrarProcessos() {
            if (this.filtroProcessos) {
                this.isLimparPesquisa = true;
                this.paginacao.paginaAtual = 1;
            }
            this.carregarProcessosJudiciaisHistorico();
        },

        async limparFiltroProcessos() {
            this.filtroProcessos = '';
            this.isLimparPesquisa = false;
            this.carregarProcessosJudiciaisHistorico();
        },

        async handlePageChange(pageNumber) {
            this.loadingTable = true;
            await this.carregarProcessosJudiciaisHistorico(pageNumber);
            this.loadingTable = false;
        },

        openModal() {
            this.modalDetalhesProcessos = true;
        },

        openAlertModal() {
            this.modalRegrasConsumo = true;
        },

        confirmarVisualizacao() {
            if (this.totalProcessos) {
                this.qdeProcessos = this.qdeProcessos ? this.qdeProcessos : 0;
                const verificarQdeExata = this.qdeProcessos > 0 ? this.qdeProcessos % this.qdeProcessosRequisicao : 0;
                if (this.qdeProcessos > 0 && this.qdeProcessos <= this.totalProcessos && (verificarQdeExata === 0 || this.qdeProcessos === this.totalProcessos)) {
                    this.isVisualizar = true;
                } else {
                    this.isVisualizar = false;
                    this.$notify.warning({
                        message: `Informe múltiplos de ` + this.qdeProcessosRequisicao + ` ou quantidade total de ` + this.totalProcessos
                    });
                }
            }
        },

        async processarConsultaProcessos() {
            this.isLoading = true;
            this.modalConfirmacaoProcessos = false;
            await this.carregarProcessosJudiciais(this.qdeProcessos);
            this.isLoading = false;
        },

        atualizarCreditos() {
            this.qdeCreditos = this.qdeProcessos ? Math.ceil(this.qdeProcessos / this.qdeProcessosRequisicao) : 0;
            this.isVisualizar = false;
        },

        atualizarMaisCreditos() {
            this.qdeMaisCreditos = this.qdeMaisProcessos ? Math.ceil(this.qdeMaisProcessos / this.qdeProcessosRequisicao) : 0;
            this.isVisualizarMais = false;
        },

        maisProcessos() {
            if (this.totalConsultados) {
                this.modalMaisProcessos = true;
            }
        },

        confirmarMaisVisualizacao() {
            const qdeRestante = this.totalProcessos ? this.totalProcessos - this.totalConsultados : 0;
            if (qdeRestante > 0) {
                this.qdeMaisProcessos = this.qdeMaisProcessos ? this.qdeMaisProcessos : 0;
                const verificarQdeExata = this.qdeMaisProcessos > 0 ? this.qdeMaisProcessos % this.qdeProcessosRequisicao : 0;
                if (this.qdeMaisProcessos > 0 && this.qdeMaisProcessos <= qdeRestante && (verificarQdeExata === 0 || this.qdeMaisProcessos === qdeRestante)) {
                    this.isVisualizarMais = true;
                } else {
                    this.isVisualizarMais = false;
                    this.$notify.warning({
                        message: `Informe múltiplos de ` + this.qdeProcessosRequisicao + ` ou quantidade total de ` + qdeRestante
                    });
                }
            }
        },

        async processarConsultaMaisProcessos() {
            this.isLoading = true;
            this.modalMaisProcessos = false;
            await this.carregarProcessosJudiciais(this.qdeMaisProcessos);
            this.isLoading = false;
        },

        loadCarregarProcessos() {
            this.modalConfirmacaoProcessos = true;
        },

        formatValorBRL(valor) {
            return 'R$ ' + formatters.formatNumber(valor, 2);
        },

        numeralStringFormatToDocumento(cpfCnpj) {
            return formatters.numeralStringFormatToDocumento(cpfCnpj);
        },

        isQsaUnificadoEmpty(input) {
            if (input.length === 0) {
                return true;
            }

            for (const item of input) {
                if (item.categoriaProcessoCriminal !== null) {
                    return false;
                }
            }

            return true;
        }
    }
};
</script>

<style lang="scss">
#processos-judiciais-totalizadores {
    border-radius: 5px 5px 0 0 !important;

    .outline-button {
        color: #00413C;
        font-weight: 400 !important;
        border: 1px solid #00413C;
        margin-top: 10px;
    }

    .arrow-icon {
        color: rgba(25, 137, 250, 1) !important;
        text-decoration: none !important;
        font-weight: 400 !important;
        font-size: 14px !important;
        margin-left: 5px;
    }

    .table-processos {
        margin-top: 15px;
    }

    .p-fix {
        word-break: keep-all;
    }

    .alert-box {
        border-radius: 5px;
        padding: 20px;
        margin-top: 8px;
        width: 100%;
        height: auto;
        border: 1px solid rgba(228, 231, 237, 1);
    }

    .titulo-card {
        font-weight: 550;
        font-size: 15px;
    }

    .alert-icon {
        background-color: rgba(230, 162, 60, 1);
        color: white;
        border-radius: 50%;
        width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        margin-right: 8px;
        flex-shrink: 0;
    }

    .centralizado {
        text-align: center;
        width: 100%;
        margin-top: 20px;
    }

    .see-more {
        grid-column: span 5;
        text-align: right;
        margin-right: 25px;
        margin-bottom: 10px;
    }

    .see-more-link {
        color: rgba(25, 137, 250, 1);
        text-decoration: none;
        font-weight: 400;
    }

    .see-more-link-regras {
        color: #359138;
        text-decoration: underline;
        font-weight: 400;
    }

    .alert-box-link {
        margin-left: 10px;
        color: rgba(25, 137, 250, 1);
        text-decoration: underline;
        font-weight: 400;
        white-space: nowrap;
    }

    i.el-icon-info {
        font-size: 16px;
        margin-left: 8px;
    }

    .info-grid {
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        border: 1px solid rgba(228, 231, 237, 1);
        border-radius: 5px;
        margin-top:8px;
        margin-bottom: 10px;
    }

    .info-item {
        position: relative;
        padding: 20px;
    }

    .info-item:not(:last-child)::after {
        content: '';
        display: block;
        width: 1px;
        background-color: rgba(228, 231, 237, 1);
        height: 50%;
        margin: auto 0;
        position: absolute;
        right: 0;
        top: 25%;
    }

    .info-grid-qde {
        display: grid;
        grid-template-columns: 350px 1fr 110px;
        grid-gap: 10px;
        width: 100%;
    }

    .info-grid-2 {
        display: grid;
        grid-template-columns: 2fr 1fr;
        grid-gap: 10px;
        width: 100%;
        margin-top: 30px;
        margin-bottom: 30px;
    }

    .info-grid-4 {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        grid-gap: 10px;
        width: 100%;
    }

    .info-grid-2-220 {
        display: grid;
        grid-template-columns: 1fr 220px;
        grid-gap: 10px;
        width: 100%;
        margin-top: 10px;
    }

    .info-grid-proc {
        display: grid;
        grid-template-columns: 220px 1fr;
        grid-gap: 10px;
        width: 100%;
        margin-bottom: 35px;
    }

    .row-border{
        border-top: 1px solid rgb(241, 240, 240);
        grid-column: 1 / 5;
    }

    .gray {
        border: 1px solid rgba(228, 231, 237, 1);
        background-color: rgb(247, 248, 250);
        border-radius: 5px;
        padding: 10px;
    }

    .gray-margin {
        border: 1px solid rgba(228, 231, 237, 1);
        background-color: rgb(247, 248, 250);
        border-radius: 5px;
        padding: 10px;
    }

    .bold {
        font-weight: bold;
    }

    .bold-red {
        font-weight: bold;
        color: rgb(199, 16, 16) ;
    }

    .bold-green {
        font-weight: bold;
        color: rgba(0, 65, 60, 1);
    }

    .label {
        font-weight: 400;
        margin-bottom: 4px;
        font-size: 12px;
    }

    .value {
        color: rgba(0, 65, 60, 1);
        font-size: 18px;
        font-weight: 500;
    }

    h1 {
        border-bottom: 1px solid #359138;
        margin-bottom: 18px;
        width: 100%;
        line-height: 42px;
    }

    i.mdi {
        color: var(--primary);
        margin-right: 10px;
        font-size: 24px;
    }

    .tabela-titulo {
        color: var(--primary);
        font-size: 18px;
        font-weight: 400;
        line-height: 21px;
        letter-spacing: 0em;
        text-align: left;
    }

    .el-collapse-item {
        border: 1px solid #d9d9d9 !important;
        border-radius: 5px;
        margin-bottom: 12px;
    }

    .el-collapse-item__header {
        position: relative;
        border-radius: 5px;
        height: 35px !important;
        padding: 22px 0px 22px 40px;
        font-size: 16px;
        font-weight: 400;
        line-height: 18px;
    }

    .el-collapse-item__arrow {
        position: absolute;
        left: 10px;
        top: 31%;
        font-size: 16px;
        font-weight: 600;
    }

    .el-collapse-item__wrap {
        padding: 12px;
        border-bottom: none !important;
    }

    .el-table {
        border-radius: 5px;

        .cell {
            word-break: break-word !important;
        }

        .el-table__body-wrapper {
            overflow-x: auto !important;
        }

        .descricao-item-tabela {
            margin-left: 55px;
            margin-right: 55px;
            max-height: 100px;
            overflow-y: auto;
        }

        .el-table__expand-icon {
            height: 24px;
            width: 24px;
            margin-bottom: 10px;
        }

        .el-table__expand-icon>.el-icon {
            color: #3b3b3b;
            font-weight: 700;
            font-size: 16px;
        }

        thead {
            color: var(--primary);
            font-size: 14px;
            font-weight: 500;
            line-height: 16.75px;

            th {
                max-width: 132px;
            }
        }

        .el-descriptions-row {
            .el-descriptions-item__label {
                color: var(--primary);
                font-weight: 500;
                font-size: 16px;
                line-height: 18.75px;
            }
        }
    }

    .table-patrimonio {
        height: 100%;
        width: 100%;
    }

    .tabela-rodape-somatorio p {
        margin-bottom: 0;
        color: var(--primary);
        font-size: 14px;
        font-weight: 500;
        line-height: 16px;
        margin-left: 21px;
        padding-top: 17px;
    }

    .el-collapse-item__content {
        padding-bottom: 5px !important;
    }

    p {
        word-break: keep-all;
        word-wrap: break-word;
        margin: 0 0 8px 0;
    }

    .button-pesquisar {
       padding: 12px;
    }
}
</style>
